module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Confirmação de Cancelamento")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [_vm._v("\n      Tem certeza de que deseja cancelar a tarefa?\n    ")]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Sim")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8da524c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Task/ModalCancel.vue
// module id = 3363
// module chunks = 0